var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textbox-base',{staticClass:"textbox-setting",attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }